import { MultiSelectOption } from '@dispatch/shared/types';
import { v4 as uuidv4 } from 'uuid';
import { dispatchClient } from '../clients';

const APIM_SERVICE_CANCEL_REASONS_URL = (tenantId: string) =>
  `configuration/${tenantId}/cancel-reasons`;

export async function getCancelReasons(
  tenantId: string
): Promise<MultiSelectOption[] | undefined> {
  try {
    const response = await dispatchClient.get<MultiSelectOption[]>(
      `${APIM_SERVICE_CANCEL_REASONS_URL(tenantId)}`,
      {
        headers: {
          'Request-ID': uuidv4(),
        },
      }
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (e) {
    /* eslint-disable no-console */
    console.error('error fetching cancel-reasons from API', e);
  }
  return undefined;
}
